import React, {state} from "react";
import { connect } from "react-redux";
import Card from "components/card";
import { PIPELINE_STEPS } from "variables/constants";


const Pipeline = ({ steps, filterHandler, activeStep, activeRejected, authUser }) => {
    if (!steps?.length) return null;

    const isClient = authUser?.user_level === 4;

    return (
        <Card className="flex flex-col gap-6 rounded-2xl shadow-lg border-2 border-slate-200 overflow-hidden dark:border dark:border-slate-700">
            <div className="bg-gradient-to-br from-slate-50 to-cyan-50 border-b rounded-t-2xl p-5 grid gap-2 dark:from-white/10 dark:to-cyan-800 dark:border-slate-700">
                <h4 className="text-[18px] dark:text-white">
                    Hiring Pipeline Overview
                </h4>
                <p className="text-[14px] text-slate-700 dark:text-slate-200">
                    Visual representation of candidate journey
                </p>
            </div>

            <div className="pb-6 p-6">
                <div className="space-y-6"> 
                    {/* <RecruitmentSearchFilter/> */}
                    {/* <div role="separator" className="w-full h-[1px] bg-slate-300"></div> */}
                    <div className="hidden lg:block px-4">
                        <div className="relative flex justify-between items-center w-full mx-auto gap-1">
                        {steps.map((step, index) => {
                            const StepIcon = PIPELINE_STEPS[step.opt_name];

                            return (<div key={index}>
                            <div  
                                className="relative flex flex-col items-center w-full justify-center m-width-[70px]"
                                >
                                {index < steps.length - 1 && (
                                <div className="absolute top-7 left-full w-full h-[2px] bg-slate-200 z-0"></div>
                                )}
                                {index > 0 && (
                                <div className="absolute top-7 right-full w-full h-[2px] bg-slate-200 z-0"></div>
                                )}

                                <div
                                className={`relative z-10 w-14 h-14 rounded-xl flex items-center justify-center mb-3 pipeline-steps cursor-pointer
                                    ${(activeStep === step.opt_id && activeRejected ===0) && 'shadow-red-500'}
                                    ${step.opt_name?.toLowerCase().replace(/\s+/g, '-')
                                } shadow-lg`}
                                    onClick={filterHandler ? ()=>filterHandler(step.opt_id) : null}
                                >
                                {StepIcon && <StepIcon className="text-white w-6 h-6" />}

                                {step.count > 0 && (
                                    <div className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-red-500 text-white flex items-center justify-center text-[10px] font-semibold border-2 border-white shadow-md">
                                    {step.count}
                                    </div>
                                )}
                                </div>

                                <span className="text-[12px] text-center max-w-[70px] leading-tight min-h-[28px] flex items-center justify-center dark:text-white">
                                {step.opt_name}
                                </span>
                            </div>

                            { !isClient &&
                            <div 
                                className={`mt-2 w-full cursor-pointer bg-gray-100 rounded-lg p-2 text-center text-[12px] dark:bg-slate-700 dark:text-white
                                ${(activeStep === step.opt_id && activeRejected === 1) && 'shadow-red-500 font-semibold text-red-500 dark:!text-red-300'}
                                } shadow-lg`}
                                onClick={filterHandler ? ()=>filterHandler(step.opt_id, 1) : null}
                            >
                                <span className="text-[12px] text-center max-w-[70px] leading-tight min-h-[28px] flex items-center justify-center">
                                   Rejected ({step.rejected_count})
                                </span>
                            </div>
                            }

                            </div>);
                        })}
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    );
};

const mapStateToProps = (state) => ({
    authUser: state.auth.user,
});
const mapDispatchToProps = () => ({
    
});

export default connect(mapStateToProps, mapDispatchToProps)(Pipeline);
